import { ErrorMessage, useField } from "formik";
import ErrorText from "./ErrorText";
import { propsTextArea } from "./FormElementos.Model.d";

export const TextArea = (props: propsTextArea) => {
    const [field, meta] = useField(props);
    return (
        <>
          <textarea className={`${props.clase} ${meta.touched && meta.error && 'is-invalid'}`} {...field} {...props} />
          <ErrorMessage name={field.name}>{ mensaje => 
              <ErrorText mensaje={mensaje} />
          }</ErrorMessage>
        </>
    );
  };
